import React from "react";
import { Link } from "react-router-dom";
import { MONEY_PLAN_PRICES } from "./Fee";
import {
  MONEY_PAID_FEATURE_DESCRIPTION,
  MONEY_PHASE1_SCOPE_NOTE,
  MONEY_STRONG_PLAN_NAME,
} from "./moneyPlanCopy";
import "./Terms.css";

function Terms() {
  const { monthlyYen, yearlyYen } = MONEY_PLAN_PRICES;

  return (
    <div className="MoneyTerms">
      <div className="MoneyTerms-inner">
        <h1>利用規約（ととのう固定費）</h1>
        <p className="muted">
          この利用規約（以下「本規約」）は、作田陽樹（以下「開発者」）が提供する iOS アプリ「ととのう固定費」（以下「本アプリ」）および関連サービス（以下「本サービス」）の利用条件を定めるものです。
          利用者は、本規約に同意のうえ本サービスを利用するものとします。
        </p>

        <h2>第1条（適用）</h2>
        <p>
          本規約は、利用者と開発者との間の本サービス利用に関わる一切の関係に適用されます。
          開発者が本サービス上で別途定めるルール等（以下「個別規定」）がある場合、個別規定は本規約の一部を構成します。
          個別規定と本規約が矛盾する場合は、個別規定が優先するものとします。
        </p>

        <h2>第2条（利用登録・アカウント）</h2>
        <p>
          利用者は、開発者が定める方法（メールアドレス、Sign in with Apple 等）により利用登録を行います。
          登録情報に虚偽があった場合、開発者は利用登録を承認しない、または利用を停止することがあります。
          利用者は、自己の責任においてアカウント情報を管理し、第三者に利用させてはなりません。
        </p>

        <h2>第3条（提供機能）</h2>
        <p>
          本サービスは、サブスクリプション・ローン等の固定費の登録・管理、集計表示、通知等を目的とした機能を提供します。
          開発者は、利用者に事前通知のうえ、機能の追加・変更・停止を行うことがあります。
          無料で利用できる機能と{MONEY_STRONG_PLAN_NAME}で利用できる機能の範囲は、
          <Link to="/money/fee"> 料金ページ</Link>
          およびアプリ内の表示に従います。
        </p>
        <p>
          初回リリース時点では、{MONEY_STRONG_PLAN_NAME}により提供される機能は<strong>{MONEY_PAID_FEATURE_DESCRIPTION}</strong>です。
          {MONEY_PHASE1_SCOPE_NOTE}
        </p>

        <h2>第4条（料金・サブスクリプション）</h2>
        <p>
          本サービスには無料プランと、App Store 経由で購入する自動更新サブスクリプション（お金に強くなるプラン）があります。
          {MONEY_STRONG_PLAN_NAME}の料金（税込）は次のとおりです（App Store の表示が優先されます）。
        </p>
        <table>
          <thead>
            <tr>
              <th>プラン</th>
              <th>料金</th>
              <th>更新周期</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>お金に強くなるプラン（月間）</td>
              <td>¥{monthlyYen.toLocaleString("ja-JP")}</td>
              <td>1か月</td>
            </tr>
            <tr>
              <td>お金に強くなるプラン（年間）</td>
              <td>¥{yearlyYen.toLocaleString("ja-JP")}</td>
              <td>1年</td>
            </tr>
          </tbody>
        </table>
        <ul>
          <li>
            サブスクリプションの購入・決済・解約・返金は、Apple Inc. が定める App Store の規約および手続に従います。開発者は、利用者のクレジットカード番号等の決済情報を直接取得しません。
          </li>
          <li>
            サブスクリプションは、各更新日の24時間以上前までに解約しない限り、契約期間終了時に自動更新されます。更新料金は、解約手続完了時点で有効な App Store の価格が適用されます。
          </li>
          <li>
            無料トライアルまたは割引価格を提供する場合、期間終了後は通常料金が自動的に請求されることがあります。詳細は購入画面の表示に従います。
          </li>
          <li>
            法令上認められる場合を除き、いったん支払われた利用料の返金は行いません。サブスクリプション期間の途中で解約した場合でも、日割り・月割りでの返金は行いません。
          </li>
          <li>
            解約手続は、iPhone の「設定」→「Apple ID」→「サブスクリプション」から行ってください。手順の詳細は
            <Link to="/money/withdrawal"> サブスクリプションの解約について</Link>
            をご覧ください。
          </li>
        </ul>

        <h2>第5条（広告）</h2>
        <p>
          本アプリは現時点で第三者広告の配信を行っていません。今後導入する場合は、本規約およびプライバシーポリシーを更新して周知します。
        </p>

        <h2>第6条（禁止事項）</h2>
        <p>利用者は、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
        <ul>
          <li>法令または公序良俗に違反する行為</li>
          <li>不正アクセス、リバースエンジニアリング等の解析行為</li>
          <li>本サービスの運営を妨害する行為</li>
          <li>第三者になりすます行為</li>
          <li>他の利用者または第三者の権利・利益を侵害する行為</li>
          <li>本サービスの有料機能を不正に利用する行為</li>
          <li>その他、開発者が不適切と判断する行為</li>
        </ul>

        <h2>第7条（データの取扱い）</h2>
        <p>
          本サービスの利用に伴い、利用者が入力した固定費データ等が、認証・同期のため外部サービス上に保存される場合があります。
          個人情報を含む利用者情報の取扱いは、別途定める
          <Link to="/money/privacy_policy"> プライバシーポリシー</Link>
          に従います。
        </p>

        <h2>第8条（アカウント削除・退会）</h2>
        <p>
          利用者は、本アプリ内のアカウント画面等からアカウント削除を行うことができます。
          <strong>端末からアプリを削除しただけでは、クラウド上のデータやサブスクリプションは解約・削除されません</strong>。
          データ削除を希望する場合はアカウント削除を、課金の停止を希望する場合は App Store でサブスクリプションを解約してください。
          手順は
          <Link to="/money/delete_app"> アプリ削除／アカウント削除について</Link>
          をご覧ください。
        </p>

        <h2>第9条（免責）</h2>
        <p>
          本サービスは、固定費管理の補助を目的とするものであり、税務・金融・法律上の助言を提供するものではありません。
          集計結果・シミュレーション結果の正確性・完全性を保証するものではなく、利用者の判断と責任においてご利用ください。
          開発者の故意または重過失がある場合を除き、本サービスに起因して利用者に生じた損害について責任を負いません。
        </p>

        <h2>第10条（規約の変更）</h2>
        <p>
          開発者は、必要に応じて本規約を変更することができます。変更後の本規約は、本ページの掲示その他適切な方法で周知し、周知後に利用者が本サービスを利用した場合、変更に同意したものとみなします。
        </p>

        <h2>第11条（準拠法・管轄）</h2>
        <p>
          本規約の準拠法は日本法とし、本サービスに関連して紛争が生じた場合、開発者の所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
        </p>

        <h2>お問い合わせ</h2>
        <p>
          本サービスに関するお問い合わせは、以下へご連絡ください。
          <br />
          連絡先：haruki2021promoter@gmail.com
        </p>

        <h2>改定日・制定日</h2>
        <p>
          改定日：2026年5月15日
          <br />
          制定日：2026年5月15日
        </p>
      </div>
    </div>
  );
}

export default Terms;
